export const getAuthorisedNavList = (navList, authroisedNavItems) => navList.map(list => ({
  title: list.title,
  navItems: list.navItems.filter(navItem => authroisedNavItems.includes(navItem))
})).filter(list => list.navItems.length > 0);
export const getFirstNavItem = (navList, authroisedNavItems) => {
  const authNavList = getAuthorisedNavList(navList, authroisedNavItems);

  // This will return the first nav link item
  return authNavList[0].navItems[0];
};